import { theme } from 'aimo-ui';
import styled from 'styled-components/native';
import { IndicatorType } from 'types/IconTypes';
import { testIdentifiers } from 'utils/testIdentifiers';

const indicatorColor = (type: IndicatorType) => {
  switch (type) {
    case 'error':
      return theme.colors.aimoUiRed;
    case 'success':
      return theme.colors.boost.green;
    case 'warning':
      return theme.colors.boost.yellow;
  }
};

export const IndicatorShape = styled.View<{
  type: IndicatorType;
  fullSize: boolean;
  border: boolean;
}>`
  position: ${({ fullSize }) => (fullSize ? 'relative' : 'absolute')};
  top: ${({ fullSize }) => (fullSize ? 0 : -4)}px;
  right: ${({ fullSize }) => (fullSize ? 0 : -4)}px;
  width: 15px;
  height: 15px;
  border-radius: 8px;
  background-color: ${({ type }: { type: IndicatorType }) =>
    indicatorColor(type)};
  align-items: center;
  justify-content: center;
  border-width: ${({ border }) => (border ? 1.5 : 0)}px;
  border-color: ${theme.colors.gray300};
`;

export const IndicatorNumber = styled.Text<{
  type: IndicatorType;
}>`
  font-size: 10px;
  font-weight: 700;
  color: ${({ type }: { type: IndicatorType }) =>
    type === 'warning' ? theme.colors.black : theme.colors.white};
`;

const IconIndicator = ({
  indicatorNumber,
  indicatorType,
  testID,
  fullSize = false,
  border = false,
}: {
  indicatorType: IndicatorType;
  indicatorNumber?: number;
  testID?: string;
  fullSize?: boolean;
  border?: boolean;
}) => {
  return (
    <IndicatorShape
      border={border}
      fullSize={fullSize}
      type={indicatorType}
      {...testIdentifiers(`${testID}-indicator-${indicatorType}`)}>
      <IndicatorNumber
        type={indicatorType}
        {...testIdentifiers(`${testID}-indicator-${indicatorNumber}`)}>
        {indicatorNumber}
      </IndicatorNumber>
    </IndicatorShape>
  );
};

export default IconIndicator;
